import { AccountTrendSettings } from '@/modules/global-settings/shared/services/account-trend.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Creates a new instance of the AccountTrendSettings class
const accountTrendService = new AccountTrendSettings();
// Export module state
export const state = {
  accountTrends: []
};
// Export module mutations
export const mutations = {
  ...make.mutations(state)
};
// Export module actions
export const actions = {
  /**
   * Get account trends
   * @async
   * @param {object} context - Vuex commit
   * @returns {Array} - Account trends
   * @private This will update the accountTrends state
   */
  getTrends: async ({ commit }) => {
    try {
      const { data } = await accountTrendService.getTrends();
      commit('SET_ACCOUNT_TRENDS', data);
      return data;
    } catch (error) {
      Logger.error('getting account trend', error);
      throw error;
    }
  },
  /**
   * Update account trends
   * @async
   * @param {object} context - Vuex commit
   * @param {object} payload - Account trend payload
   * @returns {void}
   * @private This will update the accountTrends state
   */
  updateTrends: async ({ dispatch }, payload) => {
    try {
      await accountTrendService.updateTrends(payload);
      dispatch('getTrends');
    } catch (error) {
      Logger.error('updating account trend', error);
      throw error;
    }
  }
};
// Export module getters
export const getters = make.getters(state);
